export default "__VITE_ASSET__BNu095hH__"